"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var typestyle_1 = require("typestyle");
var formatting_1 = require("./formatting/formatting");
var engine_1 = require("./engine");
var Localize_1 = require("../gen-src/Localize");
var styles_1 = require("./styles/styles");
var MetricMetadataPanel_1 = require("./MetricMetadataPanel");
var DetailTimeSeries_1 = require("./DetailTimeSeries");
var widgets_1 = require("@tableau/widgets");
var metrics_engine_1 = require("@tableau/metrics-engine");
var Colors = widgets_1.TabStyles.Colors;
var lastUpdatedStyle = {
    color: Colors.L9,
    fontSize: '12px',
};
var titleStyle = {
    color: Colors.L9,
    fontSize: '24px',
    lineHeight: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
var detailValueStyle = {
    marginTop: '24px',
    fontWeight: 300,
    fontSize: '48px',
    color: styles_1.MetricBlue,
    lineHeight: 'normal'
};
var selectedTimeStyle = {
    color: Colors.L9,
    fontSize: '14px',
    marginBottom: '40px',
    marginTop: '12px',
};
var containerStyle = {
    minWidth: '100px',
    minHeight: '100px',
    display: 'flex',
    flexDirection: 'column',
};
var graphAndMetadataContainerStyle = typestyle_1.style({ display: 'flex' }, typestyle_1.media({ minWidth: 0, maxWidth: styles_1.BreakPoints.LARGE }, { flexDirection: 'column' }), typestyle_1.media({ minWidth: styles_1.BreakPoints.LARGE + 1 }, { flexDirection: 'row' }));
var timeSeriesContainerStyle = typestyle_1.style({ height: 510 }, typestyle_1.media({ minWidth: styles_1.BreakPoints.LARGE + 1 }, { flex: 4 }));
var MetricDetailView = /** @class */ (function (_super) {
    __extends(MetricDetailView, _super);
    function MetricDetailView(props) {
        var _this = _super.call(this, props) || this;
        _this.onActivated = function (selectedValue) {
            _this.setState(function (state) {
                return {
                    selectedValue: selectedValue,
                };
            });
        };
        _this.renderTimeSeries = function () {
            if (_this.props.data && _this.props.data.length > 0) {
                return (React.createElement(DetailTimeSeries_1.ResizableDetailTimeSeries, { testId: 'time-series', data: _this.props.data, dateTrunc: _this.props.dateTrunc || metrics_engine_1.DateTrunc.UNKNOWN, onActivated: _this.onActivated, formatString: _this.props.measureFormat }));
            }
            else {
                return null;
            }
        };
        var initialValue = engine_1.getInitialValue(_this.props.data);
        _this.state = {
            selectedValue: initialValue,
        };
        return _this;
    }
    MetricDetailView.prototype.render = function () {
        return (React.createElement("div", { "data-tb-test-id": this.props.testId, style: __assign({}, containerStyle, this.props.style, { height: this.props.height, width: this.props.width }) },
            React.createElement("div", null,
                React.createElement("div", { "data-tb-test-id": 'metric-detail-value', style: detailValueStyle }, formatting_1.formatDataPointAsMetricNumber(this.state.selectedValue, this.props.measureFormat)),
                React.createElement("div", { style: selectedTimeStyle }, this.state.selectedValue ? formatting_1.formatSelectedDisplayDate(this.state.selectedValue.timestamp, this.props.dateTrunc) : '')),
            React.createElement("div", { className: graphAndMetadataContainerStyle },
                React.createElement("div", { className: timeSeriesContainerStyle }, this.renderTimeSeries()),
                React.createElement(MetricMetadataPanel_1.MetricMetadataPanel, __assign({}, this.props.metadataProps)))));
    };
    return MetricDetailView;
}(React.PureComponent));
exports.MetricDetailView = MetricDetailView;
exports.MetricRefreshTime = function (props) {
    return (React.createElement("div", { style: lastUpdatedStyle }, props.lastRefreshedTimestamp ? formatting_1.formatLastUpdatedDate(props.lastRefreshedTimestamp) : Localize_1.Messages.notUpdated()));
};
exports.MetricTitle = function (props) {
    return (React.createElement("div", { style: titleStyle }, props.metricName));
};
//# sourceMappingURL=MetricDetailView.js.map